// src/conflicts/index.ts
var InfoState = /* @__PURE__ */ ((InfoState2) => {
  InfoState2["NotFilled"] = "Data has not been added";
  InfoState2["NotFilledImport"] = "Data has been imported but not confirmed";
  InfoState2["Manual"] = "Data has been imported and manually added";
  InfoState2["NotFilledPassport"] = "Data has been used from passport";
  InfoState2["Filled"] = "Data has been entered into CAS Shield";
  InfoState2["Approved"] = "Item has been completed";
  InfoState2["Conflict"] = "Conflict between imported data and CAS Shield data";
  InfoState2["Update"] = "Item has been updated since it was imported";
  InfoState2["Pending"] = "Item is pending";
  InfoState2["Resolved"] = "Conflict in the data has been resolved";
  InfoState2["Removed"] = "Item has been removed";
  InfoState2["Skipped"] = "Item has been skipped";
  InfoState2["Optional"] = "Item cannot be checked by student";
  InfoState2["TransferMate"] = "TransferMate Payments";
  return InfoState2;
})(InfoState || {});

// src/history/enums.ts
var CourseLevel = /* @__PURE__ */ ((CourseLevel2) => {
  CourseLevel2["HIGHER"] = "HIGHER";
  CourseLevel2["SAME"] = "SAME";
  CourseLevel2["LOWER"] = "LOWER";
  CourseLevel2["NO_UK_STUDY"] = "NO_UK_STUDY";
  return CourseLevel2;
})(CourseLevel || {});

// src/visa-prep-form/index.ts
var Relationship = /* @__PURE__ */ ((Relationship2) => {
  Relationship2["GUARDIAN"] = "GUARDIAN";
  Relationship2["FRIEND"] = "FRIEND";
  Relationship2["SISTER"] = "SISTER";
  Relationship2["BROTHER"] = "BROTHER";
  Relationship2["AUNT"] = "AUNT";
  Relationship2["UNCLE"] = "UNCLE";
  Relationship2["COUSIN"] = "COUSIN";
  Relationship2["GRANDPARENT"] = "GRANDPARENT";
  Relationship2["NON_DEPENDANT"] = "NON_DEPENDANT";
  Relationship2["OTHER"] = "OTHER";
  return Relationship2;
})(Relationship || {});
var MaritalStatus = /* @__PURE__ */ ((MaritalStatus2) => {
  MaritalStatus2["SINGLE"] = "SINGLE";
  MaritalStatus2["MARRIED"] = "MARRIED";
  MaritalStatus2["UNMARRIED"] = "UNMARRIED";
  MaritalStatus2["DIVORCED"] = "DIVORCED";
  MaritalStatus2["SEPARATED"] = "SEPARATED";
  MaritalStatus2["WIDOWED"] = "WIDOWED";
  return MaritalStatus2;
})(MaritalStatus || {});
var ShareCodeStatus = /* @__PURE__ */ ((ShareCodeStatus2) => {
  ShareCodeStatus2["NONE"] = "NONE";
  ShareCodeStatus2["VERIFIED"] = "VERIFIED";
  ShareCodeStatus2["NOT_VERIFIED"] = "NOT_VERIFIED";
  ShareCodeStatus2["EXPIRING_SOON"] = "EXPIRING_SOON";
  ShareCodeStatus2["EXPIRED"] = "EXPIRED";
  return ShareCodeStatus2;
})(ShareCodeStatus || {});
export {
  CourseLevel,
  InfoState,
  MaritalStatus,
  Relationship,
  ShareCodeStatus
};
